// Modo claro / modo oscuro.
//
// El tema es una clase en <html> (`oscuro`) y nada mas: los colores de la
// paleta son variables CSS (src/styles/app.css) que cambian de valor con esa
// clase, asi que ninguna pantalla sabe en que modo esta.
//
// La eleccion se guarda POR DISPOSITIVO (localStorage), no por usuario: el
// mismo encargado puede querer el celular oscuro y la computadora del
// mostrador clara. Arranca siempre en claro; no sigue al tema del sistema, para
// que la app no le cambie de aspecto a nadie sin que lo haya pedido.
//
// La clase se pone ANTES de pintar con un script en linea en src/index.html
// (si se pusiera aca, la app destellaria en claro en cada carga). Aca esta
// solo lo que hace falta para alternarlo.

import { iconoLuna, iconoSol } from "./iconos";

const CLAVE = "tema";

export function esOscuro(): boolean {
  return document.documentElement.classList.contains("oscuro");
}

function aplicar(oscuro: boolean): void {
  document.documentElement.classList.toggle("oscuro", oscuro);
  // El color de la barra del navegador (y de la app instalada en el celular).
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", oscuro ? "#0F0F12" : "#0F1025");
  try {
    localStorage.setItem(CLAVE, oscuro ? "oscuro" : "claro");
  } catch {
    /* modo privado sin almacenamiento: el tema dura hasta recargar */
  }
}

/** El boton dice a que modo se PASA al tocarlo, no en cual se esta. */
function pintar(boton: HTMLElement): void {
  const oscuro = esOscuro();
  boton.innerHTML = `<span class="text-masa-400">${oscuro ? iconoSol : iconoLuna}</span>${
    oscuro ? "Modo claro" : "Modo oscuro"
  }`;
}

/**
 * Le da vida a todos los `[data-tema-boton]` que haya dentro de `raiz`. Hay
 * uno en el menu de la cuenta (escritorio) y otro en el menu ☰ (celular):
 * tocar cualquiera actualiza el texto de los dos.
 */
export function engancharBotonesTema(raiz: ParentNode): void {
  raiz.querySelectorAll<HTMLElement>("[data-tema-boton]").forEach((boton) => {
    pintar(boton);
    boton.addEventListener("click", () => {
      aplicar(!esOscuro());
      document.querySelectorAll<HTMLElement>("[data-tema-boton]").forEach(pintar);
    });
  });
}
